import { ViewModel, View, ObservableArray } from "binder";
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class AccountSelectorViewModel extends SelectorBaseViewModel<accountForSelector> {
    constructor(parentViewModel: ViewModel, autoRefresh:boolean=true) {
        super(parentViewModel, true);
        if(autoRefresh == true){
            this.refresh();
        }
    }

    protected async loadData(): Promise<accountForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/AccountingServices/GetAllAccounts', {
            
        });
        return result.Accounts.map(q => {
            let result = new accountForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            result.name = q.Name;
            result.code = q.Code;
            result.distinguishingDetails.update(...q.DistinguishingDetails.map(p => {
                let distinguishingDetail = new DistinguishingDetailsForAccount(this);
                distinguishingDetail.id = p.Id;
                distinguishingDetail.name = p.Name;
                distinguishingDetail.assignmentName = p.AssignmentName;
                distinguishingDetail.assignmentId = p.AssignmentId;
                return distinguishingDetail;
            }));
            return result;
        });
    }
}

export class accountForSelector extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.distinguishingDetails = ObservableArray.create<DistinguishingDetailsForAccount>();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
    public set distinguishingDetails(v: ObservableArray<DistinguishingDetailsForAccount>) { this._distinguishingDetails = v; } public get distinguishingDetails(): ObservableArray<DistinguishingDetailsForAccount> { return this._distinguishingDetails;} private _distinguishingDetails: ObservableArray<DistinguishingDetailsForAccount>;
    
}

export class DistinguishingDetailsForAccount extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set assignmentName(v: string) { this._assignmentName = v; } public get assignmentName(): string { return this._assignmentName;} private _assignmentName: string;
    public set assignmentId(v: string) { this._assignmentId = v; } public get assignmentId(): string { return this._assignmentId;} private _assignmentId: string;

    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    

}